// extracted by mini-css-extract-plugin
export default {"pageContainer":"VideosPage_pageContainer__UlL0g"};